module.exports = __webpack_public_path__ + "static/media/lk.d9b19b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lk.svg
// module id = 175
// module chunks = 0